import type { RecipeIngredient } from '@/models/firestore'

interface RecipeWithIngredients {
  ingredients?: RecipeIngredient[]
  directions?: Array<{ ingredients?: RecipeIngredient[] }>
}

/**
 * Every ingredient in a recipe: the general (unassigned) list plus each step's
 * ingredients. Recipes can have both, e.g. after an import puts most
 * ingredients on steps and leaves garnishes unassigned. Duplicates with the
 * same name, quantity and unit are counted once, as on the recipe page.
 */
export function getAllRecipeIngredients(recipe: RecipeWithIngredients): RecipeIngredient[] {
  const combined: RecipeIngredient[] = []
  const seen = new Set<string>()
  const sources = [recipe.ingredients ?? [], ...(recipe.directions ?? []).map(direction => direction.ingredients ?? [])]
  for (const ingredient of sources.flat()) {
    const key = `${ingredient.name}-${ingredient.quantity ?? ''}-${ingredient.measurement ?? ''}`
    if (seen.has(key)) continue
    seen.add(key)
    combined.push(ingredient)
  }
  return combined
}
